import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkConfig } from "@src/store/createAsyncThunk";
import {
  setCustomEventProducts,
  setCustomEventSelectedProducts,
} from "@src/store/slices/customEvents";
import {
  closeProductPicker,
  getProductPickerSelectedProducts,
} from "@src/store/slices/productPicker";

export const saveCustomEventsProductPicker = createAsyncThunk<
  void,
  void,
  ThunkConfig
>(
  "productPicker/saveCustomEventsProductPicker",
  (_, { getState, dispatch }) => {
    const products = getProductPickerSelectedProducts(getState());
    dispatch(
      setCustomEventProducts({
        products: products.map((p) => ({
          productId: p.id,
          handle: p.handle,
        })),
      })
    );
    dispatch(setCustomEventSelectedProducts(products));

    dispatch(closeProductPicker());
  }
);
